import React, { useCallback, useState, useEffect, useMemo } from "react";
import Checkbox from "../../ui-library/Checkbox/Checkbox";
import styled from "styled-components";
import SecondaryButton from "../../ui-library/Buttons/SecondaryButton/SecondaryButton";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import { useTranslation } from "react-i18next";
import { DateFormat, getExtendedDateFormat } from "../../../modules/constants";
import { DEFAULT_MOMENT_LOCALE, getCurrentLocale } from "../../../i18n/helpers";

const MissedSchoolWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledLabel = styled.label`
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
`;

const StyledDate = styled.p`
  margin-bottom: 2rem;
`;
const StyledCheckboxWrapper = styled.div`
  display: flex;
  margin-top: 10px;
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 38px;
  @media (max-width: 576px) {
    padding-top: 2rem;
    margin-top: auto;
    .btn {
      width: 100%;
    }
  }
`;

const AddMissedSchool = (props) => {
  const {
    date,
    onSubmit,
    onClose,
    didntFeelWell,
    studyVisitOrMedicalApt,
    submitting,
  } = props;

  const [didntFeelWellTemp, setDidntFeelWellTemp] = useState(false);
  const [studyVisitOrMedicalAptTemp, setStudyVisitOrMedicalAptTemp] =
    useState(false);

  const { t } = useTranslation();

  const formattedDate = useMemo(() =>
    date.locale(getCurrentLocale()).format(getExtendedDateFormat())
  );

  useEffect(() => {
    if (didntFeelWell) {
      setDidntFeelWellTemp(didntFeelWell);
    }
  }, [didntFeelWell]);

  useEffect(() => {
    if (studyVisitOrMedicalApt) {
      setStudyVisitOrMedicalAptTemp(studyVisitOrMedicalApt);
    }
  }, [studyVisitOrMedicalApt]);

  const submitForm = useCallback(() => {
    const formData = {
      didntFeelWell: didntFeelWellTemp,
      studyVisitOrMedicalApt: studyVisitOrMedicalAptTemp,
      date: date
        .locale(DEFAULT_MOMENT_LOCALE)
        .format(DateFormat.EXTENDED_DATETIME),
      missedSchool: true,
      reasonForChange: "",
    };
    onSubmit(formData);
  }, [didntFeelWellTemp, studyVisitOrMedicalAptTemp, onSubmit, date]);

  return (
    <MissedSchoolWrapper>
      <StyledDate>{formattedDate}</StyledDate>
      <p>{t("appText.dieDiary.missedSchool.select")}</p>
      <StyledCheckboxWrapper className="mt-2">
        <Checkbox
          tabIndex={1}
          data-testid="feel-well-checkbox"
          checked={didntFeelWellTemp}
          onClick={(e) => setDidntFeelWellTemp((prevState) => !prevState)}
          icon={true}
          square={true}
        />
        <StyledLabel
          className="ms-2"
          data-testid="feel-well-label"
          onClick={(e) => setDidntFeelWellTemp((prevState) => !prevState)}
        >
          {t("appText.dieDiary.missedSchool.select.didnotFeelWell")}
        </StyledLabel>
      </StyledCheckboxWrapper>
      <StyledCheckboxWrapper className="mt-2">
        <Checkbox
          tabIndex={2}
          data-testid="medical-appointment-checkbox"
          checked={studyVisitOrMedicalAptTemp}
          onClick={() =>
            setStudyVisitOrMedicalAptTemp((prevState) => !prevState)
          }
          icon={true}
          square={true}
        />
        <StyledLabel
          className="ms-2"
          data-testid="medical-appointment-label"
          onClick={() =>
            setStudyVisitOrMedicalAptTemp((prevState) => !prevState)
          }
        >
          {t("appText.dieDiary.missedSchool.select.appointment")}
        </StyledLabel>
      </StyledCheckboxWrapper>
      <ActionButtonsContainer>
        <SecondaryButton
          data-testid="missed-school-cancel-button"
          className="me-2"
          onClick={onClose}
        >
          {t("appText.cancel")}
        </SecondaryButton>
        <PrimaryButton
          data-testid="missed-school-confirm-button"
          onClick={submitForm}
          disabled={
            submitting || (!didntFeelWellTemp && !studyVisitOrMedicalAptTemp)
          }
        >
          {t("appText.confirm")}
        </PrimaryButton>
      </ActionButtonsContainer>
    </MissedSchoolWrapper>
  );
};

export default AddMissedSchool;
